import theme1 from './bkg-theme-1.mp4';
import theme2 from './bkg-theme-2.mp4';
import thumbTheme1 from './theme1.png';
import thumbTheme2 from './theme2.png';

const bkgThemes = [
    {
        themeSRC: theme1,
        thumbnailURL: thumbTheme1,
    },
    {
        themeSRC: theme2,
        thumbnailURL: thumbTheme2,
    },
];

export default bkgThemes;
